import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { ManagementPlanDTO } from './useGetManagementPlans';

export interface ManagementPlanPayload {
	name: string;
	description: string;
	price?: number;
	recurrentPayment?: boolean;
	notifyUnpayment?: boolean;
	notifyInvoice?: boolean;
	isListable: boolean;
	paymentMethods: string[];
	advantages: string[];
	hierarchy: string;
	interval?: string;
	intervalCount?: number;
	gracePeriod?: number | null;
	maxProps: number;
	maxSamples: number;
	maxInstallments?: number;
}

export const useCreateManagementPlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: ManagementPlanPayload) => {
			try {
				const { data } = await api.post<ManagementPlanDTO>('/management/plan/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar plano');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['management-plans'] });
			queryClient.invalidateQueries({ queryKey: ['public-plans'] });
		},
	});
};
